/**
 * @generated SignedSource<<347d40caa201f9f4de79746a145dd1ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscordIntegrationQuery$variables = Record<PropertyKey, never>;
export type DiscordIntegrationQuery$data = {
  readonly me: {
    readonly organization: {
      readonly id: any;
      readonly notificationIntegrations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: any;
            readonly name: string;
            readonly webhookUrl: string | null | undefined;
          };
        }>;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"appMe">;
  };
};
export type DiscordIntegrationQuery = {
  response: DiscordIntegrationQuery$data;
  variables: DiscordIntegrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "kind",
      "value": "DISCORD_WEBHOOK"
    }
  ],
  "concreteType": "GraphQLNotificationIntegrationConnection",
  "kind": "LinkedField",
  "name": "notificationIntegrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLNotificationIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLNotificationIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webhookUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "notificationIntegrations(kind:\"DISCORD_WEBHOOK\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscordIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appMe"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DiscordIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pictureUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuperAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandTheme",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSuspended",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspensionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspendedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creditLimitResetAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appUrlDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledFeatureFlags",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLUserTeamContext",
            "kind": "LinkedField",
            "name": "teamContext",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLTeam",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20858885c06cd6ea060368b9173d8aa3",
    "id": null,
    "metadata": {},
    "name": "DiscordIntegrationQuery",
    "operationKind": "query",
    "text": "query DiscordIntegrationQuery {\n  me {\n    ...appMe\n    organization {\n      id\n      notificationIntegrations(kind: DISCORD_WEBHOOK) {\n        edges {\n          node {\n            id\n            name\n            webhookUrl\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment appMe on GraphQLUser {\n  id\n  email\n  firstName\n  lastName\n  pictureUrl\n  isSuperAdmin\n  role\n  scopes\n  organization {\n    id\n    name\n    brandTheme\n    isSuspended\n    suspensionReason\n    suspendedAt\n    creditLimitResetAt\n    appUrlDomain\n    onboardingCompletedAt\n    enabledFeatureFlags\n  }\n  teamContext {\n    id\n    team {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e72797ee549e7e9f4ab530cffcc6e22";

export default node;
